import { SearchResults } from '../../types';
import { get } from '../apiService';
export const getSearchResults = async (
  name?: string,
  phone?: string,
  practice?: string
): Promise<{ data: SearchResults; loading: boolean }> => {
  const queryParams = new URLSearchParams();
  if (name) queryParams.append('name', name);
  if (phone) queryParams.append('phone', phone);
  if (practice) queryParams.append('practice', practice);
  const url = `https://gateway-bso7uhc0.wl.gateway.dev/resourceMatrix?${queryParams.toString()}`;
  let loading = true;
  try {
    const data = await get<SearchResults>(url);
    loading = false;
    return { data, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to fetch data');
  }
};
